/* string转换为number,进行比较 */
let strToNumCompare = function (str1, str2) {
  let result = 0;
  let nagative;
  if (!str1 && !str2) {
    return result;
  }
  if (isNaN(str1) || isNaN(str2)) {
    return null;
  }

  str1 = str1 + '';
  str2 = str2 + '';
  // 负数
  if (str1.charAt(0) === '-' && str2.charAt(0) !== '-') {
    result = -1;
    return result;
  } else if (str1.charAt(0) !== '-' && str2.charAt(0) === '-') {
    result = 1;
    return result;
  }
  if (str1.charAt(0) === '-' && str2.charAt(0) === '-') {
    str1 = str1.substring(1);
    str2 = str2.substring(1);
    nagative = true;
  }
  let len1 = str1.length;
  let len2 = str2.length;
  if (len1 > len2) {
    result = 1;
  } else if (len1 < len2) {
    result = -1;
  } else if (len1 === len2) {
    for (let i = 0; i < len1; i++) {
      if (str1[i] > str2[i]) {
        result = 1;
        break;
      } else if (str1[i] < str2[i]) {
        result = -1;
        break;
      } else if (str1[i] === str2[i]) {
        continue;
      }
    }
  }

  if (nagative) {
    result = result === 1 ? -1 : result === -1 ? 1 : 0;
  }
  return result;
};

// 获取url参数
let convertQuery = function (params) {
  let query = params.split('&');
  let out = {};
  for (let i = 0; i < query.length; i++) {
    let arr = query[i].split('=');
    let key = arr[0];
    let value = arr[1];
    out[key] = value;
  }
  return out;
};

// 是否为空
let isEmpty = function (input) {
  return input === null || input === undefined || input === '';
};

// 字节转换
let byteConvert = function (limit) {
  let size = '';
  if (limit < 0.1 * 1024) {
    size = limit.toFixed(2) + 'B'
  } else if (limit < 0.1 * 1024 * 1024) {
    size = (limit / 1024).toFixed(2) + 'KB'
  } else if (limit < 0.1 * 1024 * 1024 * 1024) {
    size = (limit / (1024 * 1024)).toFixed(2) + 'MB'
  } else {
    size = (limit / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
  }

  let sizeStr = size + '';
  let index = sizeStr.indexOf('.');
  let dou = sizeStr.substr(index + 1, 2)
  if (dou === '00') {
    return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
  }
  return size;
}

// 获取文件后缀
let fileSuffix = function (fileName) {
  var piontIndex = fileName.lastIndexOf('.');
  var fileLength = fileName.length;
  return fileName.substring(piontIndex + 1, fileLength);
}

let isString = function (str) {
  return (typeof str == 'string') && str.constructor == String;
}

// 复制
let copyToClipboard = function (text, cb) {
  if (text.indexOf('-') !== -1) {
    let arr = text.split('-');
    text = arr[0] + arr[1];
  }
  var textArea = document.createElement("textarea");
  textArea.style.position = 'fixed';
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.width = '2em';
  textArea.style.height = '2em';
  textArea.style.padding = '0';
  textArea.style.border = 'none';
  textArea.style.outline = 'none';
  textArea.style.boxShadow = 'none';
  textArea.style.background = 'transparent';
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.select();

  try {
    let successful = document.execCommand('copy');
    cb(successful);
  } catch (err) {
    cb(false);
    alert('该浏览器不支持点击复制到剪贴板');
  }
  document.body.removeChild(textArea);
}

let sumBigNumber = function (a, b) {
  var res = '',
    temp = 0;
  a = a.split('');
  b = b.split('');
  while (a.length || b.length || temp) {
    temp += ~~a.pop() + ~~b.pop();
    res = (temp % 10) + res;
    temp = temp > 9;
  }
  return res.replace(/^0+/, '');
}

/**
 * @msg: 将css样式对象转换为样式字符串
 * @param {*}
 * @return {*}
 */
let buildStyleFromObject = function (target) {
  target = target || {};
  let css = [];
  for (let key in target) {
    css.push(key + ':' + target[key]);
  }
  return css.join(';');
}

let isEmptyObject = function (input) {
  var result = input && typeof input === 'object' && Object.prototype.toString.call(input) === '[object Object]' && Object.keys(input).length === 0;
  if (result) {
    for (name in input) {
      return false;
    }
  }
  return result || false;
}

export default {
  strToNumCompare,
  convertQuery,
  isEmpty,
  isEmptyObject,
  byteConvert,
  fileSuffix,
  isString,
  copyToClipboard,
  sumBigNumber,
  buildStyleFromObject
};
